import { SearchIcon } from '@approvalmax/ui';
import { Box, Button, Dropdown, Menu, Text } from '@approvalmax/ui/src/components';
import { useDispatch } from 'modules/react-redux';
import { memo } from 'react';
import bemFactory from 'react-bem-factory';

import { selectXeroDeliveryAddress } from '../../../../../actions';
import { XeroAddress } from '../../../../../data/xero/XeroAddress';
import { getXeroAddressTypeText } from '../../../../../selectors/xero';
import { messages } from './AddressDropdown.messages';
import { AddressDropdownProps } from './AddressDropdown.types';

const qa = bemFactory.qa('reqf-xero-delivery-details-section');

export const AddressDropdown = memo<AddressDropdownProps>((props) => {
    const { addresses, disabled, onSearchClick } = props;

    const dispatch = useDispatch();
    const handleAddressSelect = (address: XeroAddress) => dispatch(selectXeroDeliveryAddress(address));

    if (!addresses.length) {
        return (
            <Button
                startIcon={<SearchIcon />}
                color='blue10'
                size='xsmall'
                data-qa={qa('dropdown-search-button')}
                onClick={onSearchClick}
            >
                {messages.searchFromContactsButton}
            </Button>
        );
    }

    return (
        <Dropdown
            placement='bottom'
            width='200px'
            closeOnClickInnerButton
            activator={
                <Button
                    startIcon={<SearchIcon />}
                    color='blue10'
                    size='xsmall'
                    disabled={disabled}
                    data-qa={qa('header-button')}
                >
                    {messages.searchButton}
                </Button>
            }
        >
            <Box spacing='8 8 0'>
                <Button
                    startIcon={<SearchIcon />}
                    color='blue10'
                    size='xsmall'
                    data-qa={qa('dropdown-search-button')}
                    onClick={onSearchClick}
                >
                    {messages.searchFromContactsButton}
                </Button>
            </Box>

            <Menu size='small' divider>
                {addresses.map((address) => (
                    <Menu.Item
                        key={address.id}
                        onClick={() => handleAddressSelect(address)}
                        data-qa={qa('dropdown-address-item')}
                        name={
                            <Text font='body' fontSize='small'>
                                <Text font='label' fontWeight='bold' spacing='0 0 8'>
                                    {getXeroAddressTypeText(address)}
                                </Text>

                                {address.text}

                                {address.attentionTo && <div>{address.attentionTo}</div>}
                            </Text>
                        }
                    />
                ))}
            </Menu>
        </Dropdown>
    );
});

AddressDropdown.displayName = 'AddressDropdown';
